import { render, staticRenderFns } from "./matriz-legal.vue?vue&type=template&id=8fff8da4&scoped=true&"
import script from "./matriz-legal.vue?vue&type=script&lang=js&"
export * from "./matriz-legal.vue?vue&type=script&lang=js&"
import style0 from "./matriz-legal.vue?vue&type=style&index=0&id=8fff8da4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fff8da4",
  null
  
)

export default component.exports